export default {
	List: {
		InputSearch: 'Nhập nội dung tìm kiếm',
		SearchTooltip:
			'Nhập nội dung khoản nộp ngân sách, mã giao dịch, số giấy nộp tiền, mã chứng từ ngân hàng, mã số thuế để tìm kiếm',
		Status: 'Trạng thái',
		GIPInfoQuery: 'Tra cứu nợ thuế',
		AddTaxPaper: 'Lập giấy nộp tiền',
		AddTaxPaperAcronym: 'Lập GNT',
		AddTaxPaperNowAcronym: 'Lập GNT nộp thay',
		FromDate: 'Từ ngày',
		ToDate: 'Đến ngày',
		Cancel: 'Hủy bỏ',
		Accept: 'Áp dụng',
		SubmissionCode: 'Mã giao dịch',
		BankPaymentCode: 'Số chứng từ NH',
		BankPaymentCodeTips: 'Mã chứng từ ngân hàng',
		All: 'Tất cả',
		DeleteMessage:
			'GNT bị xóa sẽ không thể khôi phục. Bạn có chắc chắn muốn xóa?',
		DeleteSuccess: 'Xóa giấy nộp tiền thành công.',
		TaxAuthorities: 'Cơ quan thuế',
		Bank: 'Ngân hàng',
		ValidateFromDate: 'Từ ngày phải nhỏ hơn hoặc bằng Đến ngày',
		ValidateToDate: 'Đến ngày phải lớn hơn hoặc bằng Từ ngày',
		ValidateMaxOneYear: 'Khoảng thời gian tìm kiếm không được vượt quá 1 năm.',
		FilterBy: 'Lọc theo',
		WarningChangeChapter:
			'Thông tin này được mặc định sẵn theo mã chương của Người nộp thuế. Bạn có chắc chắn muốn sửa lại?',
		NoHaveGipInfo: 'Không có nợ thuế.',
		GIPInfoQueryTitle: 'Nợ thuế còn tồn',
		GIPInfoQueryNote:
			'Thông tin nợ thuế được lấy trực tiếp từ Cơ quan thuế trả về. Thông tin chỉ bao gồm các khoản phải nộp, không bao gồm các khoản nộp thừa.',
		WarningRegisterService:
			'Vui lòng đăng ký sử dụng dịch vụ T-VAN MISA mTax để sử dụng tính năng này.',
		TheTaxCodeIsNotRegisteredServiceByTVAN:
			'Mã số thuế chưa đăng ký sử dụng dịch vụ nộp thuế qua T-VAN MISA.',
		TheTaxCodeIsNotRegisteredServiceByTVANHKD:
			'Hiện tại hệ thống chưa hỗ trợ nộp tiền thuế qua dịch vụ T-VAN đối với cá nhân, hộ kinh doanh.',
		RegisteringTVANServiceIsInProcessing: value =>
			`Tờ khai đăng ký ${value} nộp thuế điện tử đang chờ duyệt.`,
		Alert: {
			SelectAtLeastOne:
				'Vui lòng chọn ít nhất 1 khoản phải nộp để tiếp tục lập giấy nộp tiền.',
			OrderPayment:
				'Bạn vui lòng chọn khoản nộp theo đúng thứ tự từ nhỏ đến lớn để tiếp tục thanh toán.',
			DiffTaxType:
				'Mỗi GNT chỉ được lập cho 01 loại thuế gồm Thuế nội địa/Thuế trước bạ, vui lòng kiểm tra lại.',
			DiffTaxAgency:
				'Mỗi GNT chỉ nộp cho 01 cơ quan quản lý thu, vui lòng kiểm tra lại.',
			DiffAccount:
				'Mỗi GNT chỉ lập cho các khoản phải nộp có cùng tài khoản nộp NSNN, vui lòng kiểm tra lại.',
			DiffAuthority:
				'Mỗi GNT chỉ lập cho các khoản phải nộp có cùng tên Nộp văn bản theo cơ quan có thẩm quyền, vui lòng kiểm tra lại.',
			DiffTreasury:
				'Mỗi GNT chỉ lập cho các khoản phải nộp có cùng tên Kho bạc nhận khoản thu, vui lòng kiểm tra lại.',
			DiffDbhc:
				'Mỗi GNT chỉ lập cho các khoản nộp có cùng ĐBHC, vui lòng kiểm tra lại.',
			PendingPayment:
				'Khoản nộp bạn chọn đã được lập GNT vẫn chưa có kết quả từ ngân hàng thanh toán. Vui lòng chờ thêm ít phút để hệ thống xử lý, tránh nộp trùng hoặc sai thứ tự.',
			DiffCurrency:
				'Mỗi GNT chỉ được lập cho 01 loại tiền VND/USD. Bạn có muốn thay đổi loại tiền không?',
			MultipleValidationErrors: criteria =>
				`Các khoản phải nộp đã chọn không đủ điều kiện để lập chung 1 giấy nộp tiền. Bạn vui lòng kiểm tra lại các thông tin: ${criteria}.`
		}
	},
	SelectBankPayment: 'Chọn ngân hàng nộp thuế',
	SelectBankSubContent:
		'Giấy nộp tiền sẽ đáp ứng theo mẫu mới C1-02/NS đáp ứng Nghị định 11/2020/NĐ-CP với các ngân hàng:',
	BankPayment: 'Ngân hàng thanh toán',
	Bank: 'Ngân hàng',
	NoteBankOther:
		'Với các ngân hàng khác, mẫu giấy nộp tiền sẽ đáp ứng theo thông tư số 84/2016/TT-BTC.',
	SelectBankEmpty: 'Vui lòng chọn ngân hàng trước khi tiếp tục!',
	PleaseSelectBank: 'Vui lòng chọn ngân hàng'
};
